import { render, staticRenderFns } from "./StepTwo.vue?vue&type=template&id=7a24fe35"
import script from "./StepTwo.vue?vue&type=script&lang=ts"
export * from "./StepTwo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports